<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-dialog v-if="isView" v-model="isView" persistent width="400">
        <v-card class="mt-3 pa-1">
            <Title title="パスワード変更">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-floppy"
                    name="変更"
                    @click="onClickSave()" />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-form ref="form">
                    <v-container fluid>
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                    v-model="editItems.newPassword" 
                                    dense
                                    clearable
                                    prepend-icon="mdi-lock-question"
                                    label="パスワード"
                                    append-icon="mdi-autorenew"
                                    @click:append="onClickGeneratePassword"
                                    outlined
                                    :rules="[validatorRequire, validatorLength, validatorCombination]" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import jsSHA from "jssha"
    export default {
        components: {
            Title,
            TitleButton
        },
        data: function () {
            return {
                isView: false,
                targetLicense: null,
                editItems: {
                    newPassword: ""
                },
                validatorRequire: value => !!value || '必須入力です。',
                validatorLength: value => value.length == 8 || '8文字で入力して下さい。',
                validatorCombination: value => this.checkPasswordCharacterCombination(value) || '英字大小及び数値の組み合わせを入力して下さい。'
            }
        },
        methods: {
            /**
             * パスワードの作成ボタン押下時
             */
            onClickGeneratePassword: function () {
                this.editItems.newPassword = this.generateRandomString(8)
            },
            /**
             * 変更ボタン押下時
             */
            onClickSave: function () {
                if (!this.$refs.form.validate()) {
                    return
                }
                const self = this
                console.log("code", this.targetLicense.code)
                db.collection("licenses").doc(this.targetLicense.code).update(
                    {
                        "password": this.generateHashedString(this.editItems.newPassword)
                    }
                ).then(function(){
                    self.$store.commit("notification", {message:"ライセンスのパスワードを変更しました。", isError: false})
                    self.isView = false
                }).catch(function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"ライセンスのパスワード変更に失敗しました。"+error, isError: true})
                })
            },
            /**
             * 指定された桁数のランダムな文字列を作成して返す
             */
            generateRandomString: function (length) {
                const characters = "0123456789abcdefghjkmnprstuwxyzAEFHKLMNR"
                var code = ""
                console.log("-------------")
                for (var i=0; i<length; i++) {
                    const index = Math.floor(Math.random() * characters.length)
                    code += (characters.substr(index, 1))
                    console.log(index, characters.length)
                }
                if (this.checkPasswordCharacterCombination(code)) {
                    return code
                }
                console.log("password combination ng --> recreate")
                return this.generateRandomString(length)
            },
            /**
             * 指定されたパスワードの文字の組み合わせが問題ないか否かを返す
             */
            checkPasswordCharacterCombination: function (value) {
                return /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{8}$/.test(value)
            },
            /**
             * 指定された文字列をハッシュ化して返す
             */
            generateHashedString: function (text) {
                const sha256 = new jsSHA("SHA-256", "TEXT")
                sha256.update(text)
                return sha256.getHash("HEX")
            },
            /**
             * このダイアログを表示
             */
            show: function (license) {
                this.editItems.newPassword = ""
                this.targetLicense = license
                this.isView = true
            }
        }
    }
</script>
